var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-searchable-list",class:[
        { 'cf-c-searchable-list--shadowed': _vm.shadowed },
        { 'cf-c-searchable-list--flying-list': _vm.flyingList },
        { 'cf-c-searchable-list--p-sm': _vm.paddingSm }
    ]},[_c('div',{staticClass:"cf-c-searchable-list__search"},[_vm._t("input")],2),_c('div',{staticClass:"cf-c-searchable-list__items",class:[{ 'cf-c-searchable-list__items--5items': _vm.show5Items }]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }